<template>
  <div>
    <h3>{{ $t("related_recipes") }}</h3>
    <div class="grid" v-if="recipes">
      <div class="col-3" v-for="(item, index) in recipes.data" :key="index">
        <router-link
          class="container-recipe"
          :to="{
            name: 'singleRecipe',
            params: {
              category: $route.params.category,
              id: item.id,
            },
          }"
        >
          <div
            class="product-grid-item card image-background-list"
            :style="{
              backgroundImage: 'url(' + getCoverImage(item) + ')',
            }"
          ></div>
          <div class="product-grid-item-bottom">
            <h4>{{ $t(item.attributes.key) }}</h4>
            <div class="text-right">
              <div class="timing-category">
                <i class="pi pi-clock"></i>
                {{
                  item.attributes.cooking_time +
                    item.attributes.prep_time +
                    " Min"
                }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import RecipeService from "../../service/RecipeService";
export default {
  data() {
    return {
      recipes: null,
      recipeService: null,
    };
  },
  computed: {
    singleRecipe: function() {
      return this.$store.getters["recipes/getRecipe"];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
  },
  created() {
    this.recipeService = new RecipeService();
  },
  async mounted() {
    this.recipes = await this.recipeService.getRecipes(this.access_token, {
      "pagination[pageSize]": 4,
      "filters[category][key][$eq]": this.singleRecipe.category.data.attributes
        .key,
      fields: "key, cooking_time, prep_time",
      "populate[labels][fields][0]": "key,title,locale",
      "populate[media][fields][1]": "url",
    });
    this.importRecipesTranslations();
  },
  methods: {
    getCoverImage(item) {
      let cover = "";
      const regex = new RegExp(/_[0-9]*_[a-zA-Z0-9]*.png/);
      item.attributes.media.data.forEach((element) => {
        if (!element.attributes.url.match(regex)) {
          cover = element.attributes.url;
        }
      });
      return cover;
    },
    async importRecipesTranslations() {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      this.recipes.data.forEach((elem) => {
        var path = elem.attributes.key;
        elem.attributes.labels.data.forEach((label) => {
          let index = translations.findIndex(
            (x) => x.locale === label.attributes.locale
          );
          var value = label.attributes.title;
          var obj = translations[index].labels;
          var parts = path.split("."),
            part;
          var last = parts.pop();
          // eslint-disable-next-line no-cond-assign
          while ((part = parts.shift())) {
            if (typeof obj[part] != "object") obj[part] = {};
            obj = obj[part]; // update "pointer"
          }
          obj[last] = value;
        });
      });
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, {
          ...old,
          ...elem.labels,
        });
      });
    },
  },
};
</script>

<style></style>
